import { render, staticRenderFns } from "./ImportProcessStartedNotification.vue?vue&type=template&id=1af75340&scoped=true&"
import script from "./ImportProcessStartedNotification.vue?vue&type=script&lang=js&"
export * from "./ImportProcessStartedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af75340",
  null
  
)

export default component.exports